import React from "react";
import { Route, Switch } from "react-router-dom";
import ApplicationDetails from "./ApplicationDetails";
import ApplicationView from "./ApplicationView";

export const Application: React.FC<any> = (): JSX.Element => {
   return (
      <>
         <Switch>
            <Route path="/applications/details/:id?" exact component={ApplicationDetails} />
            <Route path="/applications/:view?" component={ApplicationView} />
            <Route path="/applications" component={ApplicationView} />
         </Switch>
      </>
   );
};

export default Application;
